export const getCallStyling = (call, interactionTypes = []) => {
  if (!call) {
    return { priority: 99, label: '', pill: 'bg-gray-100 text-gray-800', dot: 'bg-blue-500' };
  }

  // Check if we have dynamic interaction type configuration
  const typeConfig = interactionTypes.find(type => type.value === call.type);
  
  if (call.type === 'appointment') {
    const appointmentType = call.details?.appointmentDetails?.type || '';
    const lowerCaseType = appointmentType.toLowerCase();

    if (lowerCaseType.includes('emergency')) {
      return { priority: 1, label: 'Emergency', pill: 'bg-red-100 text-red-700', dot: 'bg-blue-500' };
    }
    if (lowerCaseType.includes('new patient')) {
      return { priority: 2, label: 'New Patient', pill: 'bg-yellow-100 text-yellow-700', dot: 'bg-blue-500' };
    }
    if (lowerCaseType.includes('problem')) {
      return { priority: 2, label: 'Problem', pill: 'bg-yellow-100 text-yellow-700', dot: 'bg-blue-500' };
    }
    if (lowerCaseType.includes('cleaning')) {
        return { priority: 2, label: 'Cleaning', pill: 'bg-yellow-100 text-yellow-700', dot: 'bg-blue-500' };
    }
    if (lowerCaseType.includes('reschedule')) {
      return { priority: 3, label: 'Reschedule', pill: 'bg-green-100 text-green-700', dot: 'bg-blue-500' };
    }
    if (lowerCaseType.includes('cancel')) {
      return { priority: 3, label: 'Cancel', pill: 'bg-green-100 text-green-700', dot: 'bg-blue-500' };
    }
    
    // Default for other appointment types
    return { urgency: 4, label: appointmentType || 'Appointment', pill: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' };
  }

  // Use dynamic configuration if available
  if (typeConfig && typeConfig.styling) {
    return { 
      urgency: typeConfig.urgency || 5, 
      label: typeConfig.label, 
      pill: typeConfig.styling.pill, 
      dot: typeConfig.styling.dot 
    };
  }

  // Fallback for unknown types (original logic)
  const label = call.type.charAt(0).toUpperCase() + call.type.slice(1);
  return { priority: 5, label, pill: 'bg-gray-100 text-gray-800', dot: 'bg-blue-500' };
}; 